export default __webpack_public_path__ + "static/media/roles-and-rewards.677cde2f.svg";